import on from "../assets/Projects/on-.png";
import secret from "../assets/Projects/secret-.png";
import hey from "../assets/Projects/hey-.png";
import pix from "../assets/Projects/pix-.png";

import ft1 from "../assets/banners/foodtoken 1.jpg";
import ft2 from "../assets/banners/foodtoken 2.jpg";
import ft3 from "../assets/banners/foodtoken 3.jpg";
import ft4 from "../assets/banners/foodtoken 4.jpg";

import hey1 from "../assets/banners/hey 1.jpg";
import hey2 from "../assets/banners/hey 2.jpg";
import hey3 from "../assets/banners/hey 3.jpg";
import hey4 from "../assets/banners/hey 4.jpg";

import pix1 from "../assets/banners/pixgen 1.jpg";
import pix2 from "../assets/banners/pixgen 2.jpg";
import pix3 from "../assets/banners/pixgen 3.jpg";
import pix4 from "../assets/banners/pixgen 4.jpg";

import sbr1 from "../assets/banners/secretbookrack 1.jpg";
import sbr2 from "../assets/banners/secretbookrack 2.jpg";
import sbr3 from "../assets/banners/secretbookrack 3.jpg";
import sbr4 from "../assets/banners/secretbookrack 4.jpg";

// import react from "../assets/icons/react.png";
// import css from "../assets/icons/css.png";
// import sass from "../assets/icons/sass.png";
// import tailwind from "../assets/icons/tailwind.png";
// import nodejs from "../assets/icons/nodejs-.png";
// import mongodb from "../assets/icons/mongodb-.png";

export const projectContent = [
  {
    icon: on,
    title: "The ON! Kitchen",
    project:"Food Token Generator",
    forcss: "one",
    bannerone: ft1,
    bannertwo: ft2,
    bannerthree: ft3,
    bannerfour: ft4,
    live: "https://b39-ii-capstone-foodtokengenerator-frontend.vercel.app/",
    frontendlink:
      "https://github.com/vno-thvishnu/B39--II--capstone--foodtokengenerator-frontend",
    backendlink:
      "https://github.com/vno-thvishnu/B39--II--capstone--foodtokengenerator-backend",
    // workedon: [react, css, nodejs, mongodb],
    workedon: ["React","|", "Css","|", "Nodejs","|", "Mongodb"],

    // about:
    //   "Its a food token generator application, creater for about admin and user. User can register a new account and login it. Food are display which are created by admin (admin will edit quantity of foods and all). Once user place a order by adding a food to cart and he can buy it, once he order confrimed TOKEN will generate. its helps to admin make a food and delivered it in orderwise, once food ready user gut the notification in mail and also he check it orderhistory.",
  
    about : "The web application generates food tokens for administrators and users. When a user places an order, a token is generated. This helps administrators create and deliver food in an orderly manner. Once the food is ready, the user receives an email notification and can view the order history."
    },
  {
    icon: hey,
    title: "Hey!",
    project:"Chat Application",
    forcss: "two",
    bannerone: hey1,
    bannertwo: hey2,
    bannerthree: hey3,
    bannerfour: hey4,
    live: "https://fsd-hey-chat-application-frontend.vercel.app/",
    frontendlink:
      "https://github.com/vno-thvishnu/FSD--Hey---Chat-application--frontend",
    backendlink:
      "https://github.com/vno-thvishnu/FSD--Hey---Chat-application--backend",
    // workedon: [react, css, nodejs, mongodb],
    workedon: ["React","|", "Css","|", "Nodejs","|", "Mongodb"],
    // about: "Its a chat application. User's can register and login. In this, user can see the other users who are using and they follow and unfollow each other. Once they followed chat was created between them, now they can start chatting with use of SOCKET.IO . Other thing is user can upload cover and profile pictures , they can edit also. Because of CLOUNDINARY."
about: "It's a chat application. Users can register and login. In this way, users can see the other users who are using it, and they can follow and unfollow each other. Once they followed each other, a chat option was created between them; now they can start chatting with the use of SOCKET.IO. Another feature is that users can upload and edit cover and profile pictures with the use of CLOUNDINARY."
  },

  {
    icon: pix,
    title: "PixGen",
    project:"Image Generator",
    forcss: "three",
    bannerone: pix1,
    bannertwo: pix2,
    bannerthree: pix3,
    bannerfour: pix4,
    live: "https://fsd-pix-gen-image-generator-frontend.vercel.app/",
    frontendlink:
      "https://github.com/vno-thvishnu/FSD--PixGen---Image-Generator--frontend",
    backendlink:
      "https://github.com/vno-thvishnu/FSD--PixGen---Image-Generator--backend",
    // workedon: [react, tailwind, nodejs, mongodb],
    workedon: ["React","|", "Tailwind","|", "Nodejs","|", "Mongodb"],
    // about:"Its a imgae generator. User's can register and login. they can see the post which are shared by community by others. In create page user can generate a new AI image by giving promt(anything in there imagination) with help OPEN.AI api - new image wil generate. Once generated you can share it community. We storing the image's by using CLOUNDINARY "
about:"It's an image generator. Users can register and login. They can see the posts that have been shared in the community by others. In the create page, the user can generate a new AI image by giving promt (anything in their imagination) with the help of OPEN.AI API: A new image will be generated. Once generated you can share it community. We are storing the images with CLOUNDINARY."
  },
  {
    icon: secret,
    title: "secret Bookracks",
    project:"Library Management",
    forcss: "four",
    bannerone: sbr1,
    bannertwo: sbr2,
    bannerthree: sbr3,
    bannerfour: sbr4,
    live: "https://fsd-library-management-frontend.vercel.app/",
    frontendlink:
      "https://github.com/vno-thvishnu/FSD--LibraryManagement--frontend",
    backendlink:
      "https://github.com/vno-thvishnu/FSD--LibraryManagement--backend-",
    // workedon: [react, sass, nodejs, mongodb],
    workedon: ["React","|", "Sass","|", "Nodejs","|", "Mongodb"],
// about:"Its a library management site, only for admin use. Admin can register and login. Admin can create , edit and delete a books. Admin can also create ,edit and delete a user. its helps admin to follow the borrowed books, due books and return books. Admin can allocate books to user by regestering. All user's having different Id."
about:"It's a library management application, only for admin use. Admins can register and login. Admins can create, edit, and delete books. Admins can also create, edit, and delete a user. It allows administrators to keep track of borrowed, overdue, and returned books. Admin can allocate books to users by registering. All users have different Id."  
},
];
